function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SignupPageContainer from 'js/pages/auth/SignUp/Container';
import Modal from '.';

var PremiumModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PremiumModal, _React$Component);

  function PremiumModal(props) {
    var _this;

    _classCallCheck(this, PremiumModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PremiumModal).call(this, props));

    _this.toggleOptions = function () {
      var activeHeader = _this.state.activeHeader.length ? '' : _this.state.headerText;

      _this.setState({
        showOptions: !_this.state.showOptions,
        showSignUp: !_this.state.showSignUp,
        activeHeader: activeHeader
      });
    };

    _this.state = {
      showOptions: true,
      showSignUp: false,
      headerText: 'This data is only available for COSMOS Premium. Sign up today!',
      activeHeader: 'This data is only available for COSMOS Premium. Sign up today!'
    };
    return _this;
  }

  _createClass(PremiumModal, [{
    key: "render",
    value: function render() {
      return React.createElement(Modal, _extends({}, this.props, {
        closeable: true
      }), React.createElement("div", {
        id: "PremiumModal"
      }, React.createElement("h3", {
        className: "premium-header"
      }, this.state.activeHeader), React.createElement("div", {
        className: "options ".concat(this.state.showOptions ? 'showOptions' : 'hideOptions')
      }, React.createElement(Link, {
        to: "/premium"
      }, React.createElement("button", {
        onClick: this.props.closeModal,
        className: "btn-primary"
      }, "Sign Up COSMOS Premium")), React.createElement("button", {
        onClick: this.toggleOptions,
        className: "btn-primary"
      }, "5 Day Free Trial")), React.createElement("div", {
        className: "sign-up ".concat(this.state.showSignUp ? 'showSignUp' : 'hideSignUp')
      }, React.createElement(SignupPageContainer, {
        premiumTrial: true
      }))));
    }
  }]);

  return PremiumModal;
}(React.Component);

PremiumModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  user: PropTypes.string
};
export { PremiumModal as default };